import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Cookie from 'js-cookie';
import {
  UserOnTrackSavings
} from '../../commons/index';

/**
 * @class SavingPortfolio
 */
class SavingPortfolio extends Component {
  /**
   *
   * @returns {*} - render
   */
  render() {
    const {
      targetSavings,
      fixedSavings,
      history
    } = this.props;

    Cookie.set('targetSavings', targetSavings);
    Cookie.set('fixedSavings', fixedSavings);

    const savingPortfolio = (
      <section className="body_space">
        <div className="go_back">
          <span onClick={history.goBack}>
            <i className="fa fa-arrow-left" aria-hidden="true" />
            {' '}
            {'  '}
             Go Back
          </span>
        </div>
        <div className="investment_upper_part">
          <div className="investment_upper_part_title">
            <div className="first_child">
              <h4>
            My savings
              </h4>
              <p>
            Select your savings plan of interest
              </p>
            </div>

            <div className="second_child">
              <div className="second_child_icon main">
                <i className="fas fa-search main" />
              </div>
              <div className="second_child_input main">
                <input type="text" name="" id="" placeholder="Search...." />
              </div>
              <div className="second_child_filter main my_savinngs_header_addNewLink">

                <p>
                  <Link to="/savings-plan">
                    <span>
                            +
                    </span>
                        Add new
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="savings_plan_for_interest">
          <div className="savings_category">
            <div className="d-flex justify-content-between align-items-center savings_category_header">
              <div>
                <h5>
                            Target Savings
                </h5>
              </div>
              <div>
                <Link to="/all-target-savings">
                            View All
                </Link>
              </div>
            </div>

            {/* ======================================================= */}
            {
            targetSavings.slice(0, 3).map(savings => (
              <UserOnTrackSavings
                key={savings.id}
                title={savings.planName}
                planType={savings.planType}
                amountSaved={savings.amountSaved || savings.amount}
                amountAccrued={savings.amountAccrued}
                totalInterestEarned={savings.totalInterestEarned}
                id={savings.id}
              />
            ))
          }
          </div>
        </div>

        <div className="savings_plan_for_interest">
          <div className="savings_category">
            <div className="d-flex justify-content-between align-items-center savings_category_header">
              <div>
                <h5>
                  Fixed Deposit Savings
                </h5>
              </div>
              <div>
                <Link to="/all-fixed-savings">
                View All
                </Link>
              </div>
            </div>


            {/* ============================================== */}
            {
            fixedSavings.slice(0, 3).map(savings => (
              <UserOnTrackSavings
                key={savings.id}
                title={savings.planName}
                planType={savings.planType}
                amountSaved={savings.amountSaved || savings.amount}
                amountAccrued={savings.amountAccrued}
                totalInterestEarned={savings.totalInterestEarned}
                id={savings.id}
              />
            ))
          }
          </div>
        </div>

        <div className="savings_category">
          <div className="d-flex justify-content-between align-items-center savings_category_header">
            <div>
              <h5>
              Group Contributing Scheme
              </h5>
            </div>
            <div>
              <a href="#">
                View All
              </a>
            </div>
          </div>


          {/* ============================================== */}
          {/* {
            fixedSavings.map(savings => (
              <UserOnTrackSavings
                key={savings.id}
                title={savings.planName}
                planType={savings.planType}
                amountSaved={savings.amountSaved || savings.amount}
                amountAccrued={savings.amountAccrued}
                totalInterestEarned={savings.totalInterestEarned}
                id={savings.id}
              />
            ))
          } */}
        </div>

      </section>
    );
    return <>{savingPortfolio}</>;
  }
}

export default withRouter(SavingPortfolio);
